import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "qrcode"
}
const _hoisted_2 = { class: "switch-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_z_button = _resolveComponent("z-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_z_dialog = _resolveComponent("z-dialog")!

  return (_openBlock(), _createBlock(_component_z_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: _ctx.loginType === 'account' ? '账号登录' : '微信扫码登录',
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    class: "dialog-login",
    "append-to-body": true,
    width: _ctx.dialogWidth,
    height: _ctx.dialogHeight,
    onClose: _ctx.dialogClose
  }, {
    default: _withCtx(() => [
      (!_ctx.showQrcode)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: "loginForm",
            model: _ctx.login,
            rules: _ctx.rules,
            "label-width": "0",
            class: "login-form",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createCommentVNode(" 账号密码登录区域 "),
              (_ctx.loginType === 'account')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.login.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login.email) = $event)),
                          placeholder: "请输入邮箱"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_form_item, { prop: "password" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.login.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.login.password) = $event)),
                          type: "password",
                          placeholder: "请输入密码",
                          "show-password": ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        (_ctx.loginType === 'account')
                          ? (_openBlock(), _createBlock(_component_z_button, {
                              key: 0,
                              type: _ctx.loginType === 'account' ? 'primary' : 'success',
                              class: "login-btn",
                              onClick: _ctx.handleLogin
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.loginType === 'account' ? '立即登录' : ''), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["type", "onClick"]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 原有微信二维码展示区域 "),
              (_ctx.loginType == 'wechat')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[5] || (_cache[5] = [
                    _createElementVNode("div", { id: "wechat-qrcode" }, null, -1 /* HOISTED */)
                  ])))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 切换登录方式 "),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleLoginType && _ctx.toggleLoginType(...args)))
                }, _toDisplayString(_ctx.loginType === 'account' ? '扫码登录' : '账号登录'), 1 /* TEXT */)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title", "width", "height", "onClose"]))
}